import { styled } from "styled-components";
import { useSearchspringPLPContext } from "../../contexts/SearchspringPLPContext"
import { colors, font } from "../../lib/sharedStyles";
import { SwiperCarousel, SwiperSlide } from "../Swiper";

const TermsContainer = styled.div`
  @media (min-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  > p {
    ${font('Instrument Sans', 600, '14px', '20px', '0.14px')};
    color: ${colors.fender.black};
    margin: 0 0 10px 0;
    text-align: center;

    @media (min-width: 1024px) {
      margin: 0 8px 0 0;
      text-align: left;
    }
  }
`;

const RelatedSearchTerm = styled.a`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 24px;
  border-radius: 24px;
  background: ${colors.fender.grey01};
  ${font('Instrument Sans', 600, '12px', '18px', '0.12px')};
  color: ${colors.fender.primaryDark};
  text-decoration: none;
`;

const MobileContent = styled.div`
  display: flex;
  
  @media (min-width: 1024px) {
    display: none;
  }
`;

const DesktopContent = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: flex;
    gap: 8px;
    margin-left: 8px;
  }
`;

const PLPRelatedSearchTerms = () => {
  const { relatedSearchTerms } = useSearchspringPLPContext();

  return (
    <TermsContainer>
      <p>Related Searches:</p>
      <MobileContent>
        <SwiperCarousel 
          slidesPerView="auto"
          spaceBetween={8}
          slidesOffsetAfter={16}
          slidesOffsetBefore={16}
        >
          {relatedSearchTerms.map((term, index) => (
            <SwiperSlide key={`mobile-${term}${index}`} style={{width: 'fit-content'}}>
              <RelatedSearchTerm href={`/search?q=${encodeURIComponent(term)}`}>
                {term}
              </RelatedSearchTerm>
            </SwiperSlide>
          ))}
        </SwiperCarousel>
      </MobileContent>
      <DesktopContent>
        {relatedSearchTerms.map((term, index) => (
          <RelatedSearchTerm 
            key={`desktop-${term}${index}`} 
            href={`/search?q=${encodeURIComponent(term)}`}
          >
            {term}
          </RelatedSearchTerm>
        ))}
      </DesktopContent>
    </TermsContainer>
  );
}

export default PLPRelatedSearchTerms;